var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C17.9909 0.000210742 19.199 1.20836 19.1992 2.69922V16.5C19.199 17.9909 17.9909 19.199 16.5 19.1992H2.69922C1.20836 19.199 0.000210741 17.9909 0 16.5V2.69922C0.00021116 1.20836 1.20836 0.00021116 2.69922 0H16.5ZM4.5 10.9502C4.08579 10.9502 3.75 11.286 3.75 11.7002V14.7002C3.75032 15.1141 4.08598 15.4502 4.5 15.4502C4.91384 15.45 5.24968 15.114 5.25 14.7002V11.7002C5.25 11.2861 4.91403 10.9504 4.5 10.9502ZM7.89941 8.5498C7.48538 8.55002 7.14941 8.88572 7.14941 9.2998V14.7002C7.14973 15.114 7.48558 15.45 7.89941 15.4502C8.31343 15.4502 8.6491 15.1141 8.64941 14.7002V9.2998C8.64941 8.88559 8.31363 8.5498 7.89941 8.5498ZM14.7002 3.75C14.286 3.75 13.9502 4.08579 13.9502 4.5V14.7002C13.9505 15.1141 14.2862 15.4502 14.7002 15.4502C15.1139 15.4499 15.4499 15.1139 15.4502 14.7002V4.5C15.4502 4.08598 15.1141 3.75032 14.7002 3.75ZM11.2959 6.14941C10.8818 6.14941 10.546 6.48529 10.5459 6.89941V14.6992C10.5459 15.1134 10.8817 15.4492 11.2959 15.4492C11.7101 15.4492 12.0459 15.1134 12.0459 14.6992V6.89941C12.0458 6.48529 11.71 6.14941 11.2959 6.14941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaAnalytics);
export default __webpack_public_path__ + "static/media/wa_analytics.d7a4fd65ff914895967fe27ce2f49837.svg";
export { ForwardRef as ReactComponent };